import React from 'react'
import ReportsSection from '../../component/reports/ReportsSection'

function Reports() {
  return (
    <div className='page-body'>
      <ReportsSection/>
    </div>
  )
}

export default Reports
